/**
 * Watchlist seed data - hearted listings for the mock shopper (CAT-06). The
 * entry shape is mock-only; the repository projects entries onto listings.
 * `priceAtSave` snapshots the Buy Now price at heart time (null for auctions)
 * so the favorites grid can flag price drops - listing 101 was hearted at $58
 * and now sells for $48, and listing 182 has since sold.
 */

export interface WatchlistEntry {
  id: number;
  shopperId: number;
  listingId: number;
  priceAtSave: number | null;
}

export const seedWatchlist = (): WatchlistEntry[] => [
  { id: 1, shopperId: 1, listingId: 110, priceAtSave: null },
  { id: 2, shopperId: 1, listingId: 111, priceAtSave: null },
  { id: 3, shopperId: 1, listingId: 101, priceAtSave: 58 },
  { id: 4, shopperId: 1, listingId: 104, priceAtSave: 34 },
  { id: 5, shopperId: 1, listingId: 182, priceAtSave: null }
];
